import { FetchAPI } from '../Main/fetchAPI';
import {
	ArchiveClientBehaviorsProperties,
	DeleteClientBehaviorsProperties,
	SaveClientBehaviorsProperties,
	UpdateClientBehaviorsProperties,
} from './behaviorReductionProperties';
import { BEHAVIORS, CLIENT_BEHAVIORS } from '../constants';

export const BehaviorReduction = {
	behaviors: {
		getTypes: () =>
			FetchAPI.getJson({
				urlStr: `${BEHAVIORS}/types`,
			}),
		getCategories: () =>
			FetchAPI.getJson({
				urlStr: `${BEHAVIORS}/categories`,
			}),
	},
	clients: {
		getClientBehaviors: ({
			clientId,
			funderId,
			includeArchived,
		}: {
			clientId: string;
			funderId?: string | null;
			includeArchived: boolean;
		}) => {
			const query = new URLSearchParams();
			query.set('includeArchived', String(includeArchived));
			// Funding stream scope: omit/null = insurance/DOE (shared tree); set = funder-specific (e.g. ELC).
			if (funderId) query.set('funderId', funderId);

			return FetchAPI.getJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}?${query.toString()}`,
			});
		},
		saveClientBehaviors: ({ clientId, ...data }: SaveClientBehaviorsProperties) =>
			FetchAPI.postJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}`,
				data,
			}),
		updateClientBehaviors: ({ clientId, id, ...data }: UpdateClientBehaviorsProperties) =>
			FetchAPI.putJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}/${id}`,
				data,
			}),
		deleteClientBehaviors: ({ clientId, id }: DeleteClientBehaviorsProperties) =>
			FetchAPI.deleteJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}/${id}`,
			}),
		archiveClientBehaviors: ({ clientId, id }: ArchiveClientBehaviorsProperties) =>
			FetchAPI.postJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}/${id}/archive`,
			}),
		unArchiveClientBehaviors: ({ clientId, id }: ArchiveClientBehaviorsProperties) =>
			FetchAPI.postJson({
				urlStr: `${CLIENT_BEHAVIORS(clientId)}/${id}/un-archive`,
			}),
	},
};
